(window as any).REGALIA_PLAYER_VERSION = '2.5.0';
export const REGALIA_PLAYER_VERSION = (window as any).REGALIA_PLAYER_VERSION;

type SemverParts = { major: number; minor: number; patch: number };

function parseSemver(version: string): SemverParts {
	const cleaned = String(version || '').trim();
	const parts = cleaned.split('.');
	const major = parseInt(parts[0] || '0', 10);
	const minor = parseInt(parts[1] || '0', 10);
	const patch = parseInt(parts[2] || '0', 10);
	return {
		major: Number.isFinite(major) ? major : 0,
		minor: Number.isFinite(minor) ? minor : 0,
		patch: Number.isFinite(patch) ? patch : 0,
	};
}

export function compareSemver(a: string, b: string): number {
	const left = parseSemver(a);
	const right = parseSemver(b);
	if (left.major !== right.major) return left.major > right.major ? 1 : -1;
	if (left.minor !== right.minor) return left.minor > right.minor ? 1 : -1;
	if (left.patch !== right.patch) return left.patch > right.patch ? 1 : -1;
	return 0;
}

export function isLegacyRegaliaVersion(version: string | null | undefined): boolean {
	const value = String(version || '').trim();
	return value.length === 0 || value === '0.0.0';
}
